import React from 'react';
import EditableListDescriptionContainer from './EditableListDescriptionContainer';
import MarkdownRender from '../text-editors/MarkdownRender';
import LinkifyWrapper from '../LinkifyWrapper';

const EditableListDescription = ({
  onClick,
  content,
  linkTarget,
  message = 'click.to.edit',
  markdown,
  className,
}) => (
  <EditableListDescriptionContainer
    onClick={onClick}
    message={message}
    content={content}
    className={className}
  >
    {markdown && (<MarkdownRender value={content} linkTarget={linkTarget} />)}
    {!markdown && (
      <LinkifyWrapper>
        {content}
      </LinkifyWrapper>
    )}
  </EditableListDescriptionContainer>
);

export default EditableListDescription;
